import { render, staticRenderFns } from "./KpiSettings.vue?vue&type=template&id=8d0b3396&scoped=true"
import script from "./KpiSettings.vue?vue&type=script&lang=ts"
export * from "./KpiSettings.vue?vue&type=script&lang=ts"
import style0 from "./KpiSettings.vue?vue&type=style&index=0&id=8d0b3396&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0b3396",
  null
  
)

export default component.exports